<template>
  <div class="chart-box" ref="chart1"></div>

</template>

<script>
  import {echartsMixin} from 'assets/js/common/mixin.js'
  import {dataZoom} from 'assets/js/common/echartsComm.js';

  export default {
    name: "repay",
    mixins: [echartsMixin],
    component: {},
    data() {
      return {
        chart1: '',
        echartsData: {
          cb: [20, 50, 20, 20, 40, 80, 60, 43, 65, 88, 23, 56],
          sy: [44, 30, 24, 60, 20, 49, 70, 44, 67, 34, 77, 36],
          time: ['1月', "2月", "3月", "4月", "5月", "6月", "7月", "8月", '9月', '10月', '11月', '12月'],
        },
      }
    },
    mounted() {
      this.chart1 = this.$echarts.init(this.$refs.chart1)
      this.initOption()
    },
    methods: {
      initOption() {
        let option1 = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              width: "30%",
              type: 'shadow',
              shadowStyle: {
                color: "rgba(8,104,98,0.36)"
              }
            },
            backgroundColor: "#002624",
            borderColor: '#009288',
            borderWidth: 1,
            textStyle: {
              color: "#fff",
            },
            formatter: (params) => {
              let html = "<div style='text-align:center;padding:15px'>" + params[0].name + "<br/>"
              params.forEach((val, index) => {
                html += `${val.seriesName}：<span style="color:#4CD5FF">${val.data}</span><br/>`

              })
              return html + '</div>'
            }
          },
          color: ['#e3ca04', "#29f3d9"],
          grid: {
            left: '20',
            right: '40',
            bottom: '40',
            top: "40",
            containLabel: true
          },
          legend: {
            top: '10',
            data: ['成本', '收益'],
            itemHeight: 3,
            itemWidth: 20,
            icon: 'rect',
            textStyle: {
              color: '#fff'
            },
          },
          xAxis: {
            type: 'category',
            name: '月份',
            nameTextStyle: {
              color: '#99ffcc',
              fontWeight: 'bold',
            },
            nameGap: '5',
            boundaryGap: true, //坐标轴的留白
            axisLine: {
              show: true,
              lineStyle: {
                color: "#00C3D3",
              }
            },
            axisTick: {
              show: false //坐标轴刻度
            },
            axisLabel: {
              color: '#fff',
              fontSize: 12,
              textStyle: {},
            },
            data: this.echartsData.time
          },
          yAxis: {
            type: 'value',
            name: '单位（万元/吨）',
            nameTextStyle: {
              color: '#99ffcc',
              fontWeight: 'bold',
              padding: [0, 0, 0, 20],
            },
            axisTick: {
              show: false //坐标轴刻度
            },
            axisLine: {
              lineStyle: {
                color: "#35ece6",
                type: "solid",
                opacity: 1
              }
            },
            axisLabel: {
              color: '#fff',
              fontSize: 12,
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#0C615B',
                type: "solid",

              }
            },
          },
          series: [{
            name: '成本',
            type: 'line',
            showSymbol: false,
            lineStyle: {
              type: 'solid',
            },
            itemStyle: {
              normal: {},
            },
            data: this.echartsData.cb
          }, {
            name: '收益',
            type: 'line',
            showSymbol: false,
            lineStyle: {
              type: 'solid',
            },
            itemStyle: {},
            data: this.echartsData.sy
          }],
          dataZoom
        }
        this.chart1.setOption(option1)
      },
      _resizeHanlder() {
        this.chart1.resize()
      },
      _destroyHandler() {
        if (this.chart1) {
          this.chart1.dispose()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

  .chart-box {
    width: 100%;
    height: calc(100% - 30px);

  }
</style>



// WEBPACK FOOTER //
// src/pages/pollute/charts/returnAnalysis.vue